/**
 * Converts file content to base64 string with normalized line endings
 * @param fileContent - The content of the file to be processed
 * @returns Base64 encoded string of the file content
 * @throws {Error} If the input is not a string or if encoding fails
 */
export const fileToBase64 = (fileContent: string): string => {
  if (typeof fileContent !== 'string') {
    throw new Error('Input must be a string');
  }

  try {
    const normalizedContent = fileContent.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

    // Handle both browser and Node.js environments
    if (typeof Buffer !== 'undefined') {
      // Node.js environment
      return Buffer.from(normalizedContent, 'utf8').toString('base64');
    } else if (typeof btoa === 'function' && typeof TextEncoder === 'function') {
      // Browser environment
      const utf8Bytes = new TextEncoder().encode(normalizedContent);
      return btoa(String.fromCharCode(...utf8Bytes));
    } else {
      // Fallback for older browsers without TextEncoder
      return btoa(unescape(encodeURIComponent(normalizedContent)));
    }
  } catch (error) {
    console.error('Error converting file to base64:', error);
    throw new Error('Failed to process file content');
  }
};
